/**
 * Per-year data source configuration.
 *
 * All years (including 2020) load from QuizSystem/ETSData — original studio-authored
 * content. Do NOT serve QuizSystem/ETS2020Texts|Audios|Images: that legacy corpus
 * mirrors copyrighted ETS TOEIC material and triggered AdSense DMCA (e.g.
 * /toeic2020/test10/part5/question27).
 */

const RAW_BASE = 'https://raw.githubusercontent.com/QuizSystem';

/**
 * @deprecated Always false. Kept so call sites compile; legacy ETS2020* is retired.
 */
export const isLegacy = (_year?: string): boolean => {
  return false;
};

/** Path relative to the axios baseURL (https://raw.githubusercontent.com/QuizSystem). */
export const textUrl = (year: string | undefined, test: number | string, part: number | string): string => {
  const y = year || '2020';
  return `/ETSData/master/${y}/test${test}/part${part}.json`;
};

export const audioUrl = (
  year: string | undefined,
  test: number | string,
  part: number | string,
  index: number | string
): string => {
  const y = year || '2020';
  return `${RAW_BASE}/ETSData/master/${y}/test${test}/audio/part${part}_${index}.mp3`;
};

export const imageUrl = (
  year: string | undefined,
  test: number | string,
  part: number | string,
  index: number | string
): string => {
  const y = year || '2020';
  return `${RAW_BASE}/ETSData/master/${y}/test${test}/images/part${part}_${index}.png`;
};

/**
 * Redux cache key for a test. Year-scoped to avoid collisions across editions.
 */
export const getTestKey = (year: string | undefined, testNumber: number | string): string => {
  const y = year || '2020';
  return `y${y}_test${testNumber}`;
};
